import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'promis-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() isLarge: boolean = false;

  @Input() isDisabled: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
